import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../../utils/api';

export const postCreateNewVariant = createApi('NewVariantSlice', 'POST');

const NewVariantSlice = createSlice({
  name: 'NewVariantSlice',
  initialState: {
    data: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(postCreateNewVariant.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(postCreateNewVariant.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(postCreateNewVariant.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default NewVariantSlice.reducer;